import { useSelector } from 'react-redux';

type UseDataSourceRepository = {
  getDataSourceById(id: number): any;
  getDataSourceByOriginNodeId(originNodeId: number): any;
  dataSources: any;
};

function useDataSourceRepository(): UseDataSourceRepository {
  const dataSources = useSelector((state: any) => state.entities.sources);

  function getDataSourceById(id: number) {
    return dataSources[id];
  }

  function getDataSourceByOriginNodeId(originNodeId: number) {
    return Object.values(dataSources).find(
      (dataSource: any) => dataSource.origin_node_id === originNodeId,
    );
  }

  return {
    dataSources,
    getDataSourceById,
    getDataSourceByOriginNodeId,
  };
}

export { useDataSourceRepository };
